import React from 'react';
import { PaymentStatus, UserStatus } from '../data/demoData';
type StatusBadgeProps = {
  status: UserStatus | PaymentStatus;
  size?: 'default' | 'large' | 'xlarge';
};
const styles: Record<string, string> = {
  'Waiting setup': 'bg-[#A6B6F8]/25 text-[#5B5299] ring-[#A6B6F8]/60',
  'Free trial': 'bg-[#4BE4FF]/20 text-[#041F60] ring-[#4BE4FF]/60',
  Active: 'bg-[#4BE4FF]/20 text-[#041F60] ring-[#4BE4FF]/60',
  Cancelled: 'bg-stone-100 text-stone-600 ring-stone-200',
  Pending: 'bg-[#A6B6F8]/25 text-[#5B5299] ring-[#A6B6F8]/60',
  Submitted: 'bg-[#4BE4FF]/20 text-[#041F60] ring-[#4BE4FF]/60',
  Confirmed: 'bg-[#A6B6F8]/25 text-[#5B5299] ring-[#A6B6F8]/60',
  'Paid out': 'bg-[#4BE4FF]/20 text-[#041F60] ring-[#4BE4FF]/60',
  Failed: 'bg-rose-50 text-rose-700 ring-rose-200'
};
export function StatusBadge({
  status,
  size = 'default'
}: StatusBadgeProps) {
  const sizeStyles = size === 'xlarge' ? 'px-4 py-2 text-base font-bold' : size === 'large' ? 'px-3.5 py-1.5 text-sm font-bold' : 'px-2.5 py-1 text-xs font-semibold';
  return <span className={`inline-flex items-center rounded-full ring-1 ring-inset ${sizeStyles} ${styles[status]}`} data-id="element-321" data-mp="2act81xr6ukmp">
      {status}
    </span>;
}